import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import { FaEyeSlash, FaDownload } from 'react-icons/fa';
import base_url from '../config/Config';
import axios from "axios";
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import PageLoader from '../components/PageLoader';

const Fintech = () => {
    const [fintechPartner, setFintechPartner] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');

    const getAllFintechPartner = () => {
        axios.get(`${base_url}/api1/user/fintechList`).then(
            (response) => {
                console.log(response.data);
                setFintechPartner(response.data);
            },
            (error) => {
                console.log(error);
            }
        ).finally(() => setPageLoading(false));
    };

    useEffect(() => {
        getAllFintechPartner();
    }, []);

    const handleSearch = (event) => {
        event.preventDefault();
        if (searchOption && searchInput) {
            let url = '';
            switch (searchOption) {
                case 'Fintech':
                    url = `${base_url}/api1/user/searchByPartnerName?partnerName=${searchInput}`;
                    break;
                case 'gst':
                    url = `${base_url}/api1/user/searchByGst?gst=${searchInput}`;
                    break;
                case 'phone':
                    url = `${base_url}/api1/user/searchByPhone?phone=${searchInput}`;
                    break;
                default:
                    break;
            }
            axios.get(url).then(
                (response) => {
                    console.log(response.data);
                    setFintechPartner(response.data);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    const handleExportFintech = async () => {
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api1/user/userToExport`, {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Fintech_User_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            console.log('Export Fintech successfully:', response.data);
            alert('Export Fintech successfully');
        } catch (error) {
            console.error('Error generating repayment:', error.response?.data || error.message);
            alert('Export Fintech not shown');
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <>
            <div className='overviewsaa'>
                <h4>All Fintech Partner</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            <div className='row'>
                                                <div className="col-md-3">
                                                    <div className=" required">
                                                        <select
                                                            name="option"
                                                            id="option"
                                                            className="form-control"
                                                            value={searchOption}
                                                            onChange={(e) => setSearchOption(e.target.value)}
                                                            required="required"
                                                        >
                                                            <option value="" selected="selected">Search By</option>
                                                            <option value="Fintech">Fintech Partner</option>
                                                            <option value="gst">GST Number</option>
                                                            <option value="phone">Phone</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className=" required">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search..."
                                                            value={searchInput}
                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                
                                                <div className="col-md-2">
                                                    <div className=" required">
                                                        <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="addemployee">
                                                        <NavLink to="/fintech/AddFintech" className="btn btn-sm btn-primary">Add Fintech</NavLink>
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <div className='export'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportFintech}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                    Export <FaDownload />
                                                                </>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='allcustomer table-responsive mb-5'>
                                        { pageLoading ? <PageLoader text="Loading..." /> : fintechPartner.length > 0  ? (
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>S. N.</th>
                                                        <th>Fintech Id</th>
                                                        <th>Fintech Name</th>
                                                        <th>Pan</th>
                                                        <th>Mobile Number</th>
                                                        <th>Gst Number</th>
                                                        <th>Director Name</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {fintechPartner.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{data.employeeId}</td>
                                                            <td>{data.employeeName}</td>
                                                            <td>{data.pan}</td>
                                                            <td>{data.spocMobileNumber}</td>
                                                            <td>{data.gstNumber}</td>
                                                            <td>{data.directorName}</td>
                                                            <td className='iconss'>
                                                                <NavLink to={`/fintech/ViewFintech?id=${encodeURIComponent(data.id)}`}>
                                                                    <FaEyeSlash />
                                                                </NavLink>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            "No Fintech Partner"
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Fintech;
